import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from "moment-timezone";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { timeZone } from 'src/app/utils/utils.common';
import { TripService } from 'src/app/services/core/trip/trip.service';
import { getRandomString, generatePdf } from 'src/app/utils/common.utils';
import { isiReportDownload } from '../../reports/pdf-make-reports/paramount-report';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import * as _ from 'underscore';
import { TitleCasePipe } from '@angular/common';
@UntilDestroy()
@Component({
  selector: 'app-report-configuration-modal',
  templateUrl: './report-configuration-modal.component.html',
  styleUrls: ['./report-configuration-modal.component.css']
})
export class ReportConfigurationModalComponent implements OnInit {
  @Input() selectedTrips: any;
  @Input() user: any;
  @Input() selectedCorporate: any;
  @Input() filterdataList: any;
  @Input() preLevelOfService: any;
  @Output() onCloseModal = new EventEmitter<any>();
  configurationForm!: FormGroup;
  trips:any = [];
  @Input() todayDate: any;
  tripId:any
  tripData:any
  timeZone:any = timeZone;
  reportLoader = {
    isModal: false,
    isLoading: false,
  };
  selectedTripIds:any;
  submitted= false;
  selectedFundingSourceId: any = '';
  fundingSources: any = [];
  preFundingSources: any = {};
  titleCase = new TitleCasePipe();
  billingDetail: any;

  constructor(private fb: FormBuilder,
    private tripService: TripService,
    private credentialService : CredentialService,
    private fundingSourceService: FundingSourceService,
    private billingService : BillingService,
    private sharedDataService : SharedDataService
  ) { }

  ngOnInit() {
    console.log('user', this.user);
      this.selectedTripIds = this.selectedTrips.map((trip:any) => trip.id);
    this.configurationForm = this.fb.group({
      invoiceNo: [this.generateString()],
      billingCompany: ['',Validators.required],
      billingAddress: ['', Validators.required],
      billingCompanyPhone: ['',Validators.required],
      billingCompanyEmail: ['',Validators.required],
      preInvoiceDate: [moment().toISOString()],
      invoiceDate: [moment().toISOString()],
      dueDate: [moment().tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString()],
      preDueDate: [moment().tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString()],
      outstandingInvoiceNo: [''],
      pastDue: [''],
    })
    this.getUser()
    this.getConfigurations()
    this.trips = (this.selectedTrips.length ? this.getSelectedTrips() : this.filterdataList)
      .sort((a: any, b: any) =>
        new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime()
      );
  }

  getConfigurations() {
    this.billingService.getConfigurations().subscribe((res: any) => {
      if (res?.results) {
        this.billingDetail = res.results[0];
      }
    });
  }

  get form(){
    return this.configurationForm.controls
  }


  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
       
        this.user = data;
        
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }

        if (this.user) {
          this.configurationForm.patchValue({
            billingCompany: this.user.company.name,
            billingCompanyEmail: this.user.company.email,
            billingAddress: this.user.company.address.name,
            billingCompanyPhone: this.user.company.phoneNumber
          })
        }
        // this.getFundingSources();
      }
    })
  }

  getFundingSources() {
    this.fundingSourceService
      .getPicker({ isActive: true, limit: 9999 })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          const tripFundingSourceIds = _.uniq(this.selectedTrips.map((trip: any) => trip.fundingsource));
          this.fundingSources = data.results.filter((fs: any) => tripFundingSourceIds.includes(fs.id))
            .sort((a: any, b: any) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
          this.preFundingSources = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  generateString() {
    const randomString = getRandomString(7)
    const dateTime = moment().format('MMDDYY')
    return `${randomString}-${dateTime}`;
  }

   getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.tripData = data
        console.log("tripsById", data)
      }
    })
  }

  changeInvoiceDate(event:any) {
    this.configurationForm.patchValue({
      invoiceDate: moment(event).toISOString(),
      dueDate: moment(event).tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString(),
      preDueDate: moment(event).tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString(),
    })

  }
  changeDueDate(event:any) {
    this.configurationForm.patchValue({
      dueDate: moment(event).tz(this.user?.timeZone).startOf('day').toISOString()
    })

  }


async downloadTripReport() {
  
  this.submitted = true;
  
   if(this.configurationForm.invalid){
    return
  }

  this.reportLoader.isLoading = true;
  this.reportLoader.isModal = true;

const queryParams = {
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    selectedIds: this.selectedTripIds  // no extra []
};

  this.billingService.getReportTrips(queryParams)
    .subscribe({
      next: async (trips: any) => {
        if (trips && trips.length) {
          this.tripData = trips;

          try {
            const detailsObject = await isiReportDownload(
              this.tripData,
              this.user,
              this.configurationForm.value,
              this.preLevelOfService,
              this.selectedCorporate,
              this.billingDetail
            );
            const invoiceName = 'Trip Report';
            await generatePdf(detailsObject, "download", invoiceName);
          } catch (err) {
            console.error("Error generating Trip report:", err);
          } finally {
            this.reportLoader.isLoading = false;
          }
        } else {
          this.reportLoader.isLoading = false;
        }
      },
      error: (err) => {
        console.error("Error fetching trips:", err);
        this.reportLoader.isLoading = false;
      }
    });
}


  closeModal(){
    this.onCloseModal.emit();
  }


  getSelectedTrips() {
    return this.filterdataList.filter((trip:any) => trip.isSelected);
  }


  onSelectFundingSource(fundingSourceId: any) {
    if (fundingSourceId) {
      this.clearBillingInfo();
      const fundingSource = this.preFundingSources[fundingSourceId];
      if (fundingSource) {
        this.configurationForm.patchValue({
          billingCompany: this.titleCase.transform(fundingSource.title),
          billingAddress: fundingSource?.address.name || '',
          billingCompanyPhone: fundingSource.contactNumber,
          billingCompanyEmail: fundingSource.email
        });
      }
    } else {
      this.configurationForm.patchValue({
        billingCompany: this.user.company.name,
        billingCompanyEmail: this.user.company.email,
        billingAddress: this.user.company.address.name,
        billingCompanyPhone: this.user.company.phoneNumber
      })
    }
  }

    clearBillingInfo() {
    this.configurationForm.patchValue({
      billingCompany: '',
      billingAddress: '',
      billingCompanyPhone: '',
      billingCompanyEmail: '',
    });
  }
}
